<template>
	<div class="dt_en">
		<div class="pre_detail_pc" v-if="!isPhone">
			<div class="sort_con">
				<div class="good_info flex2">
					<div class="gd_left">
						<swiper class="hn_swiper" :options="swiperOptions">
							<swiper-slide class="hn_slide flex2" v-for="(item, index) in swiperList" :key="index">
								<div class="hn_slide_img flex2">
									<img :src="item" />
								</div>
							</swiper-slide>
							<div class="swiper-pagination pagination33" slot="pagination"></div>
						</swiper>
					</div>
					<div class="gd_right">
						<p class="goods_name">{{ goodsDetail.name }}</p>
						<div class="fwb" v-html="goodsDetail.spec"></div>
					</div>
				</div>
			</div>
		</div>
		<div class="pre_detail_ph" v-if="isPhone">
			<enHeader2 :searchShow="true"></enHeader2>
			<div class="good_info">
				<div class="gd_left">
					<swiper class="hn_swiper" :options="swiperOptions29">
						<swiper-slide class="hn_slide flex2" v-for="(item, index) in swiperList" :key="index">
							<div class="hn_slide_img flex2">
								<img :src="item" />
							</div>
						</swiper-slide>
						<div class="swiper-pagination pagination33" slot="pagination"></div>
					</swiper>
				</div>
				<div class="gd_right">
					<p class="goods_name">{{ goodsDetail.name }}</p>
					<div class="fwb" v-html="goodsDetail.spec"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			gid: "",
			staticImg: this.$staticImg + "/",
			swiperList: [],
			goodsDetail: {},
			banner: '',
			swiperOptions: {
				// 分页器配置
				pagination: {
					el: ".pagination33",
					clickable: true,
				},
				// 导航按钮配置
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			},
			swiperOptions29: {
				// 分页器配置
				pagination: {
					el: ".pagination44",
					clickable: true,
				},
				// 导航按钮配置
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			},
			isPhone: this.$isMobile,
		};
	},
	created() {
		this.gid = this.$route.query.gid;
		this.banner = this.$route.query.banner;
		this.enProductdt();
	},
	methods: {
		// 系列下的产品列表
		async enProductdt() {
			const res = await this.$api.enProductdt({
				id: this.gid,
			});
			if (res.code == 1) {
				this.goodsDetail = res.data;
				var swarr = this.goodsDetail.banners.split(",");
				for (let i = 0; i < swarr.length; i++) {
					this.swiperList.push(this.staticImg + swarr[i]);
				}
			}
		},
	},
}
</script>

<style lang="scss">
@function vw($size) {
	@return $size/1920 * 100vw;
}
.dt_en {
	@font-face {
		font-family: "SourceHanSerifCN";
		src: url("../../font/SourceHanSerifCN-Heavy.otf");
	}
	font-family: "SourceHanSerifCN";
	.ho_act1 {
		color: #d43235 !important;
		font-size: 20px !important;
	}
	.pagination33 {
		bottom: 0 !important;
	}
	.pagination33 .swiper-pagination-bullet {
		width: 70px !important;
		height: 3px !important;
		border-radius: 0;
	}
	.pagination44 {
		justify-content: center !important;
	}
	.pagination44 .swiper-pagination-bullet {
		width: 30px !important;
		height: 2px !important;
		border-radius: 0;
	}
	.pre_detail_pc {
		padding-top: 140px;
		background-color: #eceaeb;
		min-height: calc(100vh - 220px);
		min-width: 900px;
		.sort_con {
			width: 100%;
			.good_info {
				align-items: flex-start;
				.gd_left {
					width: vw(520);
					position: relative;
					padding: 0 vw(20);
					background-color: #fff;
					.hn_swiper {
						width: vw(520);
						height: vw(546);
						.hn_slide {
							width: vw(520);
							height: vw(546);
							.hn_slide_img {
								width: vw(520);
								height: vw(403);
								overflow: hidden;
								img {
									width: vw(468);
									height: auto;
								}
							}
						}
						.swiper-pagination-fraction,
						.swiper-pagination-custom,
						.swiper-pagination-bullet-active {
							opacity: 1;
							background: #d43235 !important;
						}
					}
				}
				.gd_right {
					padding-left: vw(80);
					width: vw(800);
					.goods_name {
						color: #333;
						font-size: vw(44);
						line-height: 1.2;
						margin-bottom: vw(44);
						text-align: left;
					}
					.fwb {
						text-align: justify;
						color: #333;
						line-height: 1.7;
						margin-bottom: vw(44);
						img {
							max-width: 100% !important;
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 900px) {
		.pre_detail_pc {
			min-height: calc(100vh - 160px);
			.sort_con {
				.good_info {
					.gd_left {
						width: 260px;
						padding: 0 10px;
						.hn_swiper {
							width: 240px;
							height: 255px;
							.hn_slide {
								width: 240px;
								height: 255px;
								.hn_slide_img {
									width: 240px;
									height: 220px;
									img {
										width: 210px;
									}
								}
							}
							.swiper-pagination-fraction,
							.swiper-pagination-custom,
							.swiper-pagination-bullet-active {
								opacity: 1;
								background: #d43235 !important;
							}
						}
					}
					.gd_right {
						padding-left: 30px;
						width: 415px;
						.goods_name {
							font-size: 30px;
							line-height: 1.2;
							margin-bottom: 15px;
						}
						.fwb {
							line-height: 1.7;
							margin-bottom: 15px;
							img {
								max-width: 100% !important;
							}
						}
					}
				}
			}
		}
	}
	.pre_detail_ph {
		background-image: url("../../images/bgimg3.png");
		padding-top: 1.23rem;
		.good_info {
			.gd_left {
				position: relative;
				background-color: #fff;
				width: 100%;
				.hn_swiper {
					width: 100%;
					height: 10.14rem;
					.hn_slide {
						width: 100%;
						height: 10.14rem;
						.hn_slide_img {
							width: 100%;
							height: 7.8rem;
							overflow: hidden;
							img {
								width: 100%;
							}
						}
					}
					.swiper-pagination-fraction,
					.swiper-pagination-custom,
					.swiper-pagination-bullet-active {
						opacity: 1;
						background: #d43235 !important;
					}
				}
			}
			.gd_right {
				padding: 0.73rem;
				.goods_name {
					color: #333;
					font-size: 0.58rem;
					line-height: 1.2;
					margin-bottom: 0.7rem;
					font-weight: bold;
				}
				.fwb {
					text-align: justify;
					color: #333;
					line-height: 1.7;
					margin-bottom: 1rem;
					img {
						max-width: 100% !important;
					}
				}
			}
		}
	}
}
</style>